import { UrlMatchResult, UrlSegment } from '@angular/router';
import { ENTITY_MODE } from '../../../shared/typings/types/entity-mode.types';

export function entityResourceMatcher (segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length < 2) return null;

  const [modeSegment, resourceSegment] = segments;
  const modePath = modeSegment.path;
  const resourcePath = resourceSegment.path;
  const consumed = [modeSegment, resourceSegment];

  if (modePath === ENTITY_MODE.SINGLE_ENTITY_URL_PREFIX) {
    // single/:entityId/children
    return { consumed, posParams: { entityId: resourceSegment } };
  }

  if (modePath === ENTITY_MODE.MULTI_ENTITY_URL_PREFIX && resourcePath === 'all-entities') {
    // multi/all-entities/same children
    return { consumed };
  }

  if (modePath === ENTITY_MODE.MULTI_ENTITY_URL_PREFIX) {
    // multi/:networkId/same children
    // pass both clusterId and networkId is intentional for transition
    return { consumed, posParams: { clusterId: resourceSegment, networkId: resourceSegment } };
  }
  return null;
}
